import { actionCreatorFactory } from 'typescript-fsa'
import { DayLogById } from '../../types'

const actionCreator = actionCreatorFactory()

export const receiveLogs =
	actionCreator<{ day: DayLogById; label: string }>('receiveLogs')
